export const REGEX = {
  EMAIL: /\S+@\S+\.\S+/,
  PASSWORD: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/,
}
